import { Box, Stack, Text } from '@mantine/core';

import { NavLink } from 'react-router-dom';

const NumberCell = ({ cell }) => {
    const { column, row } = cell;
    const rowData = row.original;
    return (
        <Box
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'start',
                gap: '16px',
            }}>
            <Text>{rowData.numberFormatted}</Text>
        </Box>
    );
};

const NumberColumn = () => ({
    accessorKey: 'numberFormatted',
    header: 'Number',
    size: 1,
    Cell: ({ cell }) => <NumberCell cell={cell} />,
});
export default NumberColumn;
